import { zodResolver } from "@hookform/resolvers/zod/dist/zod";
import { Grid } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { HttpTransferenciaTerceros } from "./api/httpTransferenciaTerceros";
import SeccionTransferenciaTercerosCuentaNuevo from "./components/SeccionTransferenciaTercerosCuentaNuevo";
import SeccionTransferenciaTercerosDatosOperacion from "./components/SeccionTransferenciaTercerosDatosOperacion";
import { OperacionTransferenciaTercerosCuentaDetalleProvisional } from "./types/dto";
import { OperacionTransferenciaTercerosFields } from './types/fields';
import { FormOperacionTransferenciaTerceros, schemaFormOperacionTransferenciaTerceros } from "./types/types";

interface NuevoSistemaTransferenciaTercerosProps {
  codSistemaPrincipal: number
}

function NuevoSistemaTransferenciaTerceros({ codSistemaPrincipal }: NuevoSistemaTransferenciaTercerosProps) {
  const { submitOperacion } = useSubmitOperacion();

  const { setSendPromise } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)
  const [cuentasProvisionales, setCuentasProvisionales] = useState<OperacionTransferenciaTercerosCuentaDetalleProvisional[]>([])

  const formMethods = useForm<FormOperacionTransferenciaTerceros>({
    resolver: zodResolver(schemaFormOperacionTransferenciaTerceros),
    defaultValues: {
      [OperacionTransferenciaTercerosFields.CodPais]: codSistemaPrincipal,
      [OperacionTransferenciaTercerosFields.FechaAprobacion]: new Date(),
    }
  })

  const alCrearOperacionTransferenciaTerceros = useCallback((data: FormOperacionTransferenciaTerceros, selected: number) => {
    if (!cuentasProvisionales.length) {
      toast.error('Debe cargar por lo menos una cuenta.');

      return;
    }

    const payload = {
      ...data,
      [OperacionTransferenciaTercerosFields.Cuentas]: cuentasProvisionales,
      [OperacionTransferenciaTercerosFields.BitEnvio]: selected === 1 ? false : true,
      codPais: codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpTransferenciaTerceros.post,
      successMessage: 'Guardado correctamente.',
    });
  }, [cuentasProvisionales, submitOperacion, codSistemaPrincipal]);


  useEffect(() => {
    let onSend = () => console.log('on send test')
    onSend = () => formMethods.handleSubmit(data => alCrearOperacionTransferenciaTerceros(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionTransferenciaTerceros])

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SeccionTransferenciaTercerosDatosOperacion
          formMethods={formMethods}
          codSistemaPrincipal={codSistemaPrincipal}
          nuevo
        />
      </Grid>
      <Grid item xs={12}>
        <SeccionTransferenciaTercerosCuentaNuevo
          codPais={codSistemaPrincipal}
          cuentasProvisionales={cuentasProvisionales}
          setCuentasProvisionales={setCuentasProvisionales}
        />
      </Grid>
    </Grid>
  );
}

export default NuevoSistemaTransferenciaTerceros;